import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { isCookieEnabled } from '../../projectSettings/isCookieEnabled';

/**
 * Detects when an environment has switched from localStorage/header auth
 * to cookie-based auth while an existing user still has a token in localStorage.
 *
 * In cookie mode, tokens should never be in state — they live in httpOnly cookies.
 * If there's a token in state while cookie auth is enabled, the environment
 * switched from header auth to cookie auth while the user still had a
 * localStorage session.
 */
export const isAuthStorageModeMismatch = (client: DynamicClient): boolean => {
  if (!isCookieEnabled(client)) {
    return false;
  }

  // If there's a token in state, it was hydrated from localStorage.
  // In cookie mode, tokens should never be in state — they live in httpOnly cookies.
  const core = getCore(client);
  const token = core.state.get().token;

  return token !== null;
};
